const SiteSettings = {
    orderHistory: {
        showOnlyMyOrders: true,
        enableReorder: true
    }
};

export default SiteSettings;
